export const baseURL = "https://www.zhi119.com/api";
// export const baseURL = "http://192.168.255.3:8081";
